import ConfirmacionCorte from './ConfirmacionCorte';
export default ConfirmacionCorte;